
import { Component, Prop, Vue } from 'vue-property-decorator'
import { DealStatus, DealStatusColor, DealStatusText } from '@/utils/enums'

@Component({
  name: 'FBadge'
})
class FBadge extends Vue {
  @Prop() readonly state!: boolean | string

  private get dealStatusKey(): string {
    const entries = Object.entries(DealStatus)
    return entries.find(el => el[1] === this.state)![0]
  }

  private get badgeClass(): string {
    if (typeof this.state === 'boolean') {
      return this.state
        ? 'elevation-0 text-none badge active-badge'
        : 'elevation-0 text-none badge inactive-badge'
    } else {
      return `elevation-0 text-none badge ${
        DealStatusColor[this.dealStatusKey]
      }`
    }
  }

  private get badgeText(): string {
    if (typeof this.state === 'boolean') {
      return this.state ? 'Aktiv' : 'Inaktiv'
    } else {
      return DealStatusText[this.dealStatusKey]
    }
  }
}

export default FBadge
